import { Chip, styled } from '@mui/material';

export const StyledChip = styled(Chip, {
  shouldForwardProp: (propName) => propName != 'readonly'
})<{ readonly?: boolean }>(({ theme, readonly }) => ({
  minWidth: '38px',
  pointerEvents: readonly ? 'none' : 'auto',
  '&.MuiChip-outlined': {
    borderColor: theme.palette.primary.main
  },
  '&.MuiChip-filled': {
    backgroundColor: theme.palette.primary.main,
    color: 'white'
  }
}));
